export default "__VITE_ASSET__800510a5__"